(function(){
    var baseConfig = {
       paymentDetails: {
            paymentToken: null
       },
       containerId: null, 
       fontCss: ['https://fonts.googleapis.com/css?family=Open+Sans'],
       styles: {
           base: {
               default: {
                   color: '#555555',
                   textDecoration: 'none',
                   fontFamily: "'Open Sans', sans-serif",
                   boxSizing: "border-box",
                   padding: '6px 12px',
                   boxShadow: 'none',
                   fontSize: '14px',
                   borderRadius: '.25rem',
                   lineHeight: '1.42857143',
                   backgroundColor: '#fff',
                   height: '34px',
                   border: '1px solid #ccd0d2'
               },
               focus: {
                   color: '#495057',
                   borderColor: '#80bdff',
               },
               error: {
                   color: "#B00",
                   borderColor: "#B00"
               },
               valid: {
                   color: "green",
                   borderColor: 'green'
               },
               label: {
                   display: 'none'
               }
           },
           cv2: {
               container: {
                   width: "25%",
                   float: "left",
                   boxSizing: "border-box"
               },
               default: {
                   borderRadius: "0 .25rem .25rem 0"
               }
           },
           expiryDate: {
               container: {
                   width: "25%",
                   float: "left",
                   borderRadius: '0rem',
               },
               default: {
                   borderRadius: "0",
                   borderRight: "none"
               },
           },
           cardNumber: {
               container: {
                   width: "50%",
                   float: "left",
               },
               default: {
                   borderRadius: ".25rem 0 0 .25rem",
                   borderRight: "none"
               },
           }
       }
    }

    var Checkout = function($el, config) {
        this.$el = $el
        this.$detailsContainer = this.$el.find('.checkout-details')
        this.$errorContainer = this.$el.find('.checkout-errors')
        this.$resultContainer = this.$el.find('.checkout-result')
        this.$loadingContainer = this.$el.find('.checkout-loading')
        this.$formContainer = this.$el.find('.checkout-form')
        this.$btn = this.$el.find('button')
        this.paymentToken = this.$el.data('paymentToken')
        this.confirmUrl = this.$el.data('confirmUrl')
        this.connectE = this.makeConnectE(config)

        this.bind()
    }

    Checkout.prototype.bind = function () {
        this.$btn.on('click', this.submitPayment.bind(this))
    }

    Checkout.prototype.btnLoading = function () {
        this.$btn.prop('disabled', true)
        this.$btn.find('.glyphicon-shopping-cart').hide()
        this.$btn.find('.glyphicon-refresh').show()
    }

    Checkout.prototype.btnReset = function () {
        this.$btn.prop('disabled', false)
        this.$btn.find('.glyphicon-refresh').hide()
        this.$btn.find('.glyphicon-shopping-cart').show()
    }

    Checkout.prototype.showForm = function() {
        this.$loadingContainer.hide()
        this.$formContainer.fadeIn()
    }

    Checkout.prototype.generateCheckoutFormId = function () {
        var id = 'form-' + Math.random()
        id.replace('.', '')
        return id
    }

    Checkout.prototype.makeConnectE = function (config) {
        config.paymentDetails.paymentToken = this.paymentToken
        config.onIframeLoaded = this.showForm.bind(this)
        config.containerId = this.generateCheckoutFormId()
        this.$formContainer.prop('id', config.containerId)
        return new Connect.ConnectE(config, this.renderValidationErrors.bind(this));
    }

    Checkout.prototype.renderConnecteErrors = function(data) {
        var errors = null

        if (typeof data === 'string') {
            errors = new Array({message: data});
        } else if (data && data.message) {
            errors = new Array(data);
        } else {
            errors = data
        }

        this.btnReset()
        this.renderValidationErrors(errors)
    }

    Checkout.prototype.renderValidationErrors = function (errors) {
        this.$errorContainer.html('');

        if (errors && errors.length) {
            const list = document.createElement("ul");
            for (const error of errors){
                const item = document.createElement("li")
                item.innerText = error.message
                list.appendChild(item)
            }
            this.$errorContainer.append(list).fadeIn()
        } else {
            this.$errorContainer.fadeOut()
        }

     }

    Checkout.prototype.renderResult = function (data, showRetry) {
        this.$resultContainer.find('strong').html(data.title)
        this.$resultContainer.find('span').html(data.message)
        this.$resultContainer.addClass(data.panelClass)

        if (showRetry) {
            this.$resultContainer.find('a').show()
        }

        this.$detailsContainer.hide()
        this.$resultContainer.fadeIn()
    }

    Checkout.prototype.renderPaymentSuccess = function (data) {
        this.renderResult(data, false)
    }

    Checkout.prototype.renderPaymentFailure = function (result) {
        this.renderResult(
            result.responseJSON,
            (result.status != 500)
        )
    }

    Checkout.prototype.confirmPayment = function (data) {
        this.btnLoading()

        $.post(this.confirmUrl, {
            payment_token: this.paymentToken
        })
        .done(this.renderPaymentSuccess.bind(this))
        .fail(this.renderPaymentFailure.bind(this))
        .always(this.btnReset.bind(this))
    }

    Checkout.prototype.submitPayment = function () {
        this.btnLoading()

        this.connectE.executePayment()
            .then(this.confirmPayment.bind(this))
            .catch(this.renderConnecteErrors.bind(this))
    }

    $('.checkout').each(function () {
        new Checkout($(this), baseConfig)
    })
})()
